import React from "react";
import "./styles.scss";
import LoginBox from "./LoginBox";
import FooterComponent from "../../components/FooterComponent/FooterComponent";
import SharePhoto from '../../../Assets/tpmShare/Illustration.png'

const Login = () => {
  const publicURL = process.env.REACT_APP_API_BASE_URL;

  return (
    publicURL === 'https://shareapi.tpmready.com' 
    ?
    <div className="wrapper tpmShare">
      <div className="row">
        <div className="col-md-6 left-column">
          <h1>Third-Party Monitoring (TPM) Management Platform</h1>
          <img
            src={SharePhoto}
            alt="Login Visual"
            className="leftImage"
          />
        </div>
        <div className="col-md-6 right-column">
           <h1 className="mobile-only-title">
        Third-Party Monitoring (TPM) Management Platform
      </h1>
          <LoginBox isShare={true} />
        </div>
      </div>
      <FooterComponent/>
    </div>
    :
    <div className="wrapper">
      <div className="row">
        <div className="col-md-6 left-column">
          <img
            src="/assets/svg/LoginImage.svg"
            alt="Login Visual"
            className="leftImage"
          />
        </div>
        <div className="col-md-6 right-column">
          <LoginBox isShare={false} />
        </div>
      </div>
    </div>
  );
};

export default Login;
